<template>
	<!-- page-header -->
	<div class="page-header">

		<h1 class="pt-5">
		<button class="btn btn-m line-1 mb-10 mr-10" v-if="isBack" @click="back()">
			<i class="icon-arrow-line-left-centered"></i>
		</button>
			{{ getTitle }}
			<p class="sub-txt text-888">{{getDescription}}</p>
		</h1>
		<slot>
		</slot>
	</div>
	<!-- //page-header -->
</template>

<script>
export default {
  props: ['title', 'description','isBack'],
  computed: {
    getTitle(){
      return this.title;
    },
    getDescription(){
      return this.description;
    }
  },
	methods: {
		back(){
			this.$router.go(-1)
		}
	}
}
</script>

<style>

</style>
